import { render, staticRenderFns } from "./WebTwoTrainReport.vue?vue&type=template&id=9ecc5dd6&scoped=true&"
import script from "./WebTwoTrainReport.vue?vue&type=script&lang=js&"
export * from "./WebTwoTrainReport.vue?vue&type=script&lang=js&"
import style0 from "./WebTwoTrainReport.vue?vue&type=style&index=0&id=9ecc5dd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecc5dd6",
  null
  
)

export default component.exports